export default __webpack_public_path__ + "static/media/metabolism.8b63f0d6.jpg";